import { MinusCircledIcon, PlusCircledIcon } from '@radix-ui/react-icons';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ClubsDatatable } from '../components/datatables/clubsDatatable';
import ArchiveClubDialog from '../components/dialogs/ArchiveClubDialog';
import CreateNewClubDialog from '../components/dialogs/CreateNewClubDialog';
import { Button } from '../components/ui/button';
import { Dialog, DialogTrigger } from '../components/ui/dialog';
import { toast } from '../components/ui/use-toast';
import { AuthContext } from '../context/AuthContext';
import api from '../lib/api';

function ClubsPage() {
    const { auth } = useContext(AuthContext);
    const [clubs, setClubs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [createClubDialogOpen, setCreateClubDialogOpen] = useState(false);
    const [archiveClubDialogOpen, setArchiveClubDialogOpen] = useState(false);
    const { state } = useLocation();


    const fetchClubs = useCallback(() => {
        setIsLoading(true);
        api.get('https://skhrf-api.cmdigital.se/v1/clubs/')
            .then(response => {
                let clubs = response.data;

                // Find the user's club and move it to the front
                const userClubId = auth?.user?.memberOfClub;
                let userClub = null;
                if (userClubId) {
                    const userClubIndex = clubs.findIndex(club => club.id === userClubId);
                    if (userClubIndex > -1) {
                        [userClub] = clubs.splice(userClubIndex, 1); // Remove the user's club
                    }
                }

                // Sort the remaining clubs alphabetically by name
                clubs.sort((a, b) => a.name.localeCompare(b.name));

                // Add the user's club back to the front if it exists
                if (userClub) {
                    clubs.unshift(userClub);
                }

                setClubs(clubs);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching clubs:', error);
                setIsLoading(false);
            });
    }, [auth?.user?.memberOfClub]);

    useEffect(() => {
        fetchClubs();
    }, [fetchClubs]);

    useEffect(() => {
        if (state?.toast) {
          toast(state.toast);
        }
      }, [state]);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                    <div>
                    <h1 className='font-medium text-2xl'>Föreningar</h1>
                    <p className='text-muted-foreground text-sm'>Här visas alla föreningar.</p>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 pt-3'>
                        {auth.user?.superadmin && (
                            <>
                                <Dialog open={createClubDialogOpen} onOpenChange={setCreateClubDialogOpen}>
                                    <DialogTrigger asChild>
                                        <Button className='xl:col-span-2'>
                                            <PlusCircledIcon className='mr-3' />
                                            Skapa ny förening
                                        </Button>
                                    </DialogTrigger>
                                    <CreateNewClubDialog
                                        close={setCreateClubDialogOpen}
                                        isOpen={createClubDialogOpen}
                                        onClubCreated={fetchClubs}
                                    />
                                </Dialog>
                                <Dialog open={archiveClubDialogOpen} onOpenChange={setArchiveClubDialogOpen}>
                                    <DialogTrigger asChild>
                                        <Button variant='secondary' className='xl:col-span-2'>
                                            <MinusCircledIcon className='mr-3' />
                                            Arkivera förening
                                        </Button>
                                    </DialogTrigger>
                                    <ArchiveClubDialog
                                        close={setArchiveClubDialogOpen}
                                        isOpen={archiveClubDialogOpen}
                                        clubs={clubs}
                                        onClubArchived={fetchClubs}
                                    />
                                </Dialog>
                            </>
                        )}
                    </div>
                </div>
                <ClubsDatatable clubs={clubs} isLoading={isLoading} auth={auth} />
            </div>
        </div>
    );
}

export default ClubsPage;
